import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../lib/index';
import API from '../api';


class CheckIsUserExist extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            userExist: false,
            patient: {},
            trigger: false,
        };

        this.userExist = this.userExist.bind(this);
        this.userNotExist = this.userNotExist.bind(this);
    }

    componentWillMount() {
        const {steps} = this.props;

        const params = {
            national_id: steps.userID.value
        };
        API.get('/getPatient', {params}).then((res) => {
            const result = res.data;
            if (result.status == "success") {
                if (result.data.length > 0) {
                    this.setState(
                        {loading: false, userExist: true, patient: result.data[0]}
                    );
                    this.userExist()
                } else {
                    this.setState(
                        {loading: false}
                    );
                    this.userNotExist()
                }

            }
        }).catch((error) => {
            this.setState({
                error: 'Error retrieving data',
                loading: false
            });
        });
    }

    userExist() {
        const {updateStore} = this.props;
        updateStore('patient', {
            id: this.state.patient.patient_id,
            name: this.state.patient.full_name,
            email: this.state.patient.email,
            national_id: this.state.patient.registration_number,
        });

        this.setState({trigger: true});

        this.props.triggerNextStep(
            {
                value: {
                    patient_id: this.state.patient.patient_id,
                    first_name: this.state.patient.first_name,
                    last_name: this.state.patient.last_name,
                    full_name: this.state.patient.full_name,
                    email: this.state.patient.email,
                }
                , trigger: 'yes_no_isThisIsYourPhone'
            })
    }

    userNotExist() {
        const {updateStore} = this.props;

        this.setState({trigger: true});
        updateStore('patient', {
            id: null,
            name: null,
            email: null,
        });

        this.setState({trigger: true});

        this.props.triggerNextStep({value: false, trigger: 'cannot_find_you_in_system', replace: true})
    }

    render() {
        const {loading, patient, userExist} = this.state;
        const {step} = this.props;
        return (
            <div>
                {loading ? (
                    <Loading/>
                ) : (
                    userExist ? (
                        <span>{step.metadata.foundUserText} <br/> ...{patient.mobile_phone.slice(-4)}?</span>
                    ) : (
                        step.metadata.notFoundUserText
                    )
                )}
            </div>
        );
    }

}

CheckIsUserExist.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

CheckIsUserExist.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default CheckIsUserExist;
